var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.51367 14.5C4.99805 14.5 2.70117 13.1875 1.44336 11C0.185547 8.83984 0.185547 6.1875 1.44336 4C2.70117 1.83984 4.99805 0.5 7.51367 0.5C10.002 0.5 12.2988 1.83984 13.5566 4C14.8145 6.1875 14.8145 8.83984 13.5566 11C12.2988 13.1875 10.002 14.5 7.51367 14.5ZM5.13477 5.03906V5.06641C5.02539 5.39453 5.18945 5.77734 5.54492 5.91406C5.87305 6.02344 6.25586 5.85938 6.36523 5.50391L6.39258 5.47656C6.41992 5.39453 6.50195 5.33984 6.58398 5.33984H8.16992C8.41602 5.33984 8.60742 5.50391 8.60742 5.75C8.60742 5.88672 8.52539 6.02344 8.38867 6.10547L7.18555 6.78906C6.9668 6.89844 6.85742 7.11719 6.85742 7.36328V7.71875C6.85742 8.10156 7.13086 8.375 7.51367 8.375C7.86914 8.375 8.14258 8.10156 8.16992 7.74609L9.04492 7.22656C9.56445 6.92578 9.91992 6.35156 9.91992 5.75C9.91992 4.79297 9.12695 4 8.16992 4H6.58398C5.92773 4 5.35352 4.41016 5.13477 5.03906ZM6.63867 10.125C6.63867 10.6172 7.02148 11 7.51367 11C7.97852 11 8.38867 10.6172 8.38867 10.125C8.38867 9.66016 7.97852 9.25 7.51367 9.25C7.02148 9.25 6.63867 9.66016 6.63867 10.125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionTag);
export default __webpack_public_path__ + "static/media/question_tag.f647112a28c75d03930fe86ce830d374.svg";
export { ForwardRef as ReactComponent };